var MuiSnackbarContent = {
    /* put your new default props here */
    square: true,
    elevation: 1,
};
export default MuiSnackbarContent;
//# sourceMappingURL=MuiSnackbarContent.js.map